import classnames from 'classnames';
import * as React from 'react';
import { observer } from 'mobx-react';
import ReactSVG from 'react-svg';

import styles from './round-arrow.less';

interface Props {
    className?: string;
    direction: 'up' | 'down' | 'left' | 'right';
    onClick: () => void;
    hidden?: boolean;
}

function getDirection(direction: string) {
    switch (direction) {
        case 'up':
            return styles.up;
        case 'left':
            return styles.left;
        case 'right':
            return styles.right;
        default:
            return null;
    }
}

export const RoundArrow = observer<React.SFC<Props>>(
    ({ className, direction, onClick, hidden }) => (
        <div
            onClick={onClick}
            hidden={hidden}
            className={classnames(className, styles.arrow, getDirection(direction))}
        >
            <ReactSVG path="assets/images/view-more-arrow.svg" />
        </div>
    )
);
